export default __webpack_public_path__ + "static/media/Sharp Swipe.ab6c4bbc.png";